import { PowerBIDashboard } from "us.collection.admin/constants/Actions";

const {
  GET_POWERBI_REPORTS,
  GET_POWERBI_REPORTS_SUCCESS,
  GET_POWERBI_REPORTS_FAIL,
} = PowerBIDashboard;

export type PowerBIReport = {
  id: string;
  name: string;
  embedUrl: string;
};

export type PowerBIData = {
  token: string;
  reports: PowerBIReport[];
};

export type PowerBIDashboardState = {
  reports: {
    isLoading: boolean;
    data: PowerBIData | null;
  };
};

const initialState: PowerBIDashboardState = {
  reports: {
    isLoading: false,
    data: {
      token:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6InlFVXdtWFdMMTA3Q2MtN1FaMldTYmVPYjNzUSIsImtpZCI6InlFVXdtWFdMMTA3Q2MtN1FaMldTYmVPYjNzUSJ9.eyJhdWQiOiJodHRwczovL2FuYWx5c2lzLndpbmRvd3MubmV0L3Bvd2VyYmkvYXBpIiwiaXNzIjoiaHR0cHM6Ly9zdHMud2luZG93cy5uZXQvODU0YzUwODUtMjU2ZC00YjdlLWJhY2QtNzA4YTQ2NWNiN2I0LyIsImlhdCI6MTc2MTI4NDI3OSwibmJmIjoxNzYxMjg0Mjc5LCJleHAiOjE3NjEyODg2ODYsImFjY3QiOjAsImFjciI6IjEiLCJhaW8iOiJBYVFBVy84YUFBQUE0aGV3REhiNVFXdFhwMi82bXo4NGQwWTd1L1ZOaXdTc3d3bVpuU0pibDE2eVRCcTluU3hVbU1ycUJYajBZMzBENzkvaWl5RlIxcVRmY1gyb25UQkd0L0IyNVk3cWFzV3hMc3VHTnJKcTVkOGkyb2ptRmk3Yy9LZ3BHbDRzcTVNandETGtwcHQxeGhsaXgzZlFtSVZlcjRSLzhjc1FZNVh5V3RpS3hxL0hNeGo0VEc4OXFZc0FFQU5iS2ljR083UVVXb2JZSnlMOUpHNFh6eUI5RnhnOHR3PT0iLCJhbXIiOlsicnNhIiwibWZhIl0sImFwcGlkIjoiODcxYzAxMGYtNWU2MS00ZmIxLTgzYWMtOTg2MTBhN2U5MTEwIiwiYXBwaWRhY3IiOiIwIiwiZGV2aWNlaWQiOiJkMjRiYTk2Ny01YjRiLTRiZDgtYTc1OC0xM2MxYmFkMzkyMzIiLCJmYW1pbHlfbmFtZSI6Ik1hZGR1bWFnZSIsImdpdmVuX25hbWUiOiJSb3NoYW4iLCJpZHR5cCI6InVzZXIiLCJpcGFkZHIiOiIyNDAyOjQwMDA6MjMwMDo1MDc6NjFhZjoxYWI3OjQ2Nzk6NDMwMyIsIm5hbWUiOiJSb3NoYW4gTWFkZHVtYWdlIiwib2lkIjoiOGI4ODZlNTEtZWZjYS00ZGFkLTkwNGQtNWI5NzhkZWIxOTgzIiwicHVpZCI6IjEwMDMyMDAwODkwQ0REQTQiLCJyaCI6IjEuQVNzQWhWQk1oVzBsZmt1NnpYQ0tSbHkzdEFrQUFBQUFBQUFBd0FBQUFBQUFBQURvQVBrckFBLiIsInNjcCI6InVzZXJfaW1wZXJzb25hdGlvbiIsInNpZCI6IjAwOGQwNWE5LTE3MDYtMTRiZS02NDZjLTJmOTM3Y2M0ZGQ3OCIsInNpZ25pbl9zdGF0ZSI6WyJkdmNfbW5nZCIsImR2Y19jbXAiLCJrbXNpIl0sInN1YiI6IllpWXBLRWc5amg2SWsxV1NfeTNUQXRXM3p1ckVQb2d3MzJhQmtScWtCczAiLCJ0aWQiOiI4NTRjNTA4NS0yNTZkLTRiN2UtYmFjZC03MDhhNDY1Y2I3YjQiLCJ1bmlxdWVfbmFtZSI6InJvc2hhbm1hQHVuaWNvcm4tc29sdXRpb25zLmNvbSIsInVwbiI6InJvc2hhbm1hQHVuaWNvcm4tc29sdXRpb25zLmNvbSIsInV0aSI6Im9LdnFPdHBqNTB5cHhjb3c2Wk16QUEiLCJ2ZXIiOiIxLjAiLCJ3aWRzIjpbIjNlZGFmNjYzLTM0MWUtNDQ3NS05Zjk0LTVjMzk4ZWY2YzA3MCIsImI3OWZiZjRkLTNlZjktNDY4OS04MTQzLTc2YjE5NGU4NTUwOSJdLCJ4bXNfYWN0X2ZjdCI6IjMgNSIsInhtc19mdGQiOiJVLXp4UFRvTlVtR2FtclZHYkNVVDNtQmptelNKRzBJZ3dJTUwzX05UdFBzQmFtRndZVzVsWVhOMExXUnpiWE0iLCJ4bXNfaWRyZWwiOiIxIDE2IiwieG1zX3N1Yl9mY3QiOiIzIDgifQ.IMbK9f5aVAcg7WE82ka8bVweWLN5i_ymYUkokUUYdfJc2cyyXZ3uX6nko1GFntCNN82zauhD5wUhN1ZtxVINzEaUimEt6kJqK7YfKvABZ7nSOGEvYqUkYZ5TMCdh-w6iYNBnSjb0iHcFo8tEElt9QKbZBeMp4WEDkaRJzH-zO4Rha7mbDwjIBPcZBstDtURu0XUPHNARG-q3qPT3XSH89XR9xV1ooGpEyhAyR3yelxBm9Kb7D6G0k39sTl5mtC0DucyAksYNrgcnvpF4GRAvmmkPhrVbbtg2_Bh2gp0V1hc8eTrxHxv6GsaVRi4Aag6WWIHyvTKtvWGAgHJH6tMqOA",
      reports: [
        {
          id: "871375a4-e98d-40df-8f77-6130f8a7d9be",
          name: "Collection",
          embedUrl:
            "https://app.powerbi.com/reportEmbed?reportId=871375a4-e98d-40df-8f77-6130f8a7d9be&groupId=bc47e60e-9375-4148-8882-cdcdf71385bf",
        },
      ],
    },
  },
};

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case GET_POWERBI_REPORTS:
      return Object.assign({}, state, {
        reports: {
          isLoading: true,
          data: null,
        },
      });
    case GET_POWERBI_REPORTS_SUCCESS:
      return Object.assign({}, state, {
        reports: {
          isLoading: false,
          data: payload.data,
        },
      });
    case GET_POWERBI_REPORTS_FAIL:
      return Object.assign({}, state, {
        reports: {
          isLoading: false,
          data: null,
        },
      });
    default:
      return state;
  }
};
